import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
// import { AuthProvider } from './contexts/auth.context';
import { LayoutProvider } from './contexts/layout.context';
import { store } from './store/index';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      {/* <AuthProvider> */}
      <LayoutProvider>
        <App />
      </LayoutProvider>
      {/* </AuthProvider> */}
    </Provider>
  </BrowserRouter>
);